export var isResendReconnectionLinkParams = function (obj) {
    return (obj &&
        obj.applicantId !== undefined &&
        (obj.sendSms !== undefined ||
            obj.sendEmail !== undefined));
};
export var isConfirmReassignParams = function (obj) {
    return obj && obj.agencyCode !== undefined;
};
export var isConfirmRefusalParams = function (obj) {
    return obj && obj.reasonCode !== undefined;
};
export var isValidIdentityParams = function (obj) {
    return obj && obj.applicantId !== undefined;
};
export var isIncompleteIdentityParams = function (obj) {
    return (obj &&
        obj.applicantId !== undefined &&
        obj.reasonCode !== undefined);
};
export var isInvalidIdentityParams = function (obj) {
    return (obj &&
        obj.applicantId !== undefined &&
        obj.reasonCode !== undefined);
};
export var isIncompleteParams = function (obj) {
    var objParsed = obj;
    return (obj &&
        (objParsed.documentsToRequest !== undefined ||
            objParsed.requestedAdditionalProofs !== undefined ||
            objParsed.refusalReasonCodes !== undefined ||
            objParsed.comments !== undefined ||
            objParsed.refusedElements !== undefined));
};
// guard for view
export var isIncompleteModal = function (obj) {
    var objParsed = obj;
    return (obj &&
        objParsed.invalidDocuments !== undefined &&
        (objParsed.additionalProofsToRequest !== undefined || objParsed.documentsToRequest !== undefined));
};
export var isReassignmentModal = function (obj) {
    var objParsed = obj;
    return obj && objParsed.agencies !== undefined;
};
export var isRefusalModal = function (obj) {
    var objParsed = obj;
    return obj && objParsed.reasons !== undefined && objParsed.defaultReasonCode !== undefined;
};
export var isValidIdentityModal = function (obj) {
    var objParsed = obj;
    return (obj &&
        objParsed.title !== undefined &&
        objParsed.lastOpenInstructionTime !== undefined &&
        objParsed.submitActionLink !== undefined &&
        objParsed.submitButtonLabel !== undefined &&
        obj.identityStatusReasons === undefined);
};
export var isIncompleteIdentityModal = function (obj) {
    var objParsed = obj;
    return obj && objParsed.identityStatusReasons !== undefined;
};
export var isInvalidIdentityModal = function (obj) {
    var objParsed = obj;
    return obj && objParsed.identityStatusReasons !== undefined;
};
export var isResendReconnectionLinkModal = function (obj) {
    var objParsed = obj;
    return obj && objParsed.submitActionLink !== undefined;
};
export var isRedirectTask = function (obj) {
    var objParsed = obj;
    return obj && objParsed.to !== undefined && objParsed.openInNewTab !== undefined;
};
